import { render, staticRenderFns } from "./ColumnTransactionStatusPagbank.vue?vue&type=template&id=1ff9d064&scoped=true"
import script from "./ColumnTransactionStatusPagbank.vue?vue&type=script&lang=js"
export * from "./ColumnTransactionStatusPagbank.vue?vue&type=script&lang=js"
import style0 from "./ColumnTransactionStatusPagbank.vue?vue&type=style&index=0&id=1ff9d064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff9d064",
  null
  
)

export default component.exports